import React, { Component } from 'react';
import { Icon, Grid } from 'semantic-ui-react';

export default class InterestsList extends Component {
    state = {
        interests: [{
            icon: 'paw',
            name: 'Animals'
        }, {
            icon: 'soccer',
            name: 'Football',

        }, {
            icon: 'book',
            name: 'Learning'
        }, {
            icon: 'travel',
            name: 'Travel',
        }, {
            icon: 'tv',
            name: 'Movies'
        }, {
            icon: 'hand spock',
            name: 'Series'
        }]
    };

    render () {
        const { interests } = this.state;

        return (
            <Grid padded verticalAlign={"middle"}>
                <Grid.Row columns={3}>
                {(() => {
                    return interests.map((interest, key) => {                        
                        return (
                            <Grid.Column key={key} style={{margin: '10px 0'}}>
                                <Icon style={{color: '#5b8fdb', fontSize: '1.5em'}} name={interest.icon}/> 
                                <span style={{fontSize: '1.25em', color: '#777'}}>{interest.name}</span>
                            </Grid.Column>
                        );                       
                    });
                })()}
                </Grid.Row>
            </Grid>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/InterestsList.js